import './alert.less'
//
import React from 'react';
import ReactDom from 'react-dom';
//import $ from 'jquery';

//
import Component from '../core/component';
import Enhance from '../core/enhance';

//
import Animate from '../common/animate'
import View from '../mobile/view';
import tools from "../libs/tools";

let showDom = null;
let self;

/**
 *
 */
class Alert extends Component {
    timeout = null;
    state = {
        show: false,
        title: ''
    };
    
    constructor(props) {
        super(props);
        
        $.extend(this.state, this.props);
        
        if (!showDom) {
            showDom = $(`<div id="${tools.uuid()}"></div>`)[0];
            $(document.body).append(showDom);
            self = this;
            
            Object.defineProperty(window, "alert", {
                value: (title) => {
                    return new Promise((resolve, reject) => {
                        this.setState({
                            show: true,
                            title,
                            onConfirm: () => {
                                resolve(true);
                            },
                            onCancel: () => {
                                resolve(false);
                            }
                        });
                    })
                },
                enumerable: true,
                configurable: false,
                writable: false
            });
            
            Object.defineProperty(window, "Alert", {
                value: (title) => {
                    return new Promise((resolve, reject) => {
                        this.setState({
                            show: true,
                            title,
                            onConfirm: () => {
                                resolve(true);
                            },
                            onCancel: () => {
                                resolve(false);
                            }
                        });
                    })
                },
                enumerable: true,
                configurable: false,
                writable: false
            });
        }
    }
    
    /**
     *
     * @return {{$$typeof, key, children, containerInfo, implementation}}
     */
    render() {
        return ReactDom.createPortal(
            <div className="c-alert">
                <Animate name={this.state.show ? 'fadeIn' : 'fadeOut'} display={this.state.show}
                         className="c-alert-overlay fast"/>
                <Animate name={this.state.show ? 'fadeIn' : 'fadeOut'} display={this.state.show}
                         className="c-alert-modal faster">
                    <div className="modal-inner">
                        <div className="modal-title">
                            <View>{this.state.title}</View>
                        </div>
                    </div>
                    <div className="modal-buttons ">
                        <span className="modal-button modal-button-bold"
                              onClick={(e) => {
                                  this.setState({show: false});
                                  this.state.onConfirm && this.state.onConfirm();
                              }}>
                            确定
                        </span>
                    </div>
                </Animate>
            </div>, showDom
        );
    }
}

Alert.displayName = "Alert";
export default Alert
